import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, Flame, Wand2, Trophy, BarChart3 } from "lucide-react";

const items = [
  { to: "/home", label: "Home", icon: Home, testId: "nav-home" },
  { to: "/daily", label: "Daily", icon: Flame, testId: "nav-daily" },
  { to: "/challenge/new", label: "Prime", icon: Wand2, testId: "nav-prime" },
  { to: "/leaderboards/prime", label: "Ranks", icon: Trophy, testId: "nav-leaderboard" },
  { to: "/stats", label: "Stats", icon: BarChart3, testId: "nav-stats" },
];

const HIDE_ON = ["/splash", "/"];

export const BottomNav = () => {
  const loc = useLocation();
  if (HIDE_ON.includes(loc.pathname)) return null;
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 inset-x-0 z-40 backdrop-blur-xl bg-[#0A090D]/85 border-t border-white/10"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="max-w-md mx-auto grid grid-cols-5 py-2 px-2">
        {items.map(({ to, label, icon: Icon, testId }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={testId}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 py-1.5 rounded-lg transition-colors ${
                isActive ? "text-[#FF107A]" : "text-[#FDFBF7]/60 hover:text-[#FDFBF7]"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon size={20} strokeWidth={isActive ? 2.5 : 2} />
                <span className="text-[10px] tracking-[0.15em] uppercase font-semibold">{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
